import { createCustomTheme } from '../components/solteq-react/styles/theme';

export const theme = createCustomTheme({
    settingsMenu: {
        display: 'none'
    },
    topMenu: {
        iconColor: '#fff'
    },
    palette: {
        primary: {
            main: '#000'
        }
    },
    overrides: {
        MuiDrawer: {
            root: {
                display: 'none'
            }
        },
        MuiAppBar: {
            root: {
                '& .MuiButtonBase-root': {
                    marginLeft: 50
                }
            }
        }
    }
});
